import { Signal } from "@suse-o11y/signal";
import { usePermanent } from "@suse-o11y/use-permanent";
import React from "react";

import { Table } from "~/components/table";
import { TableBody } from "~/components/table/body";
import { TableCell } from "~/components/table/cell";
import { TableHead } from "~/components/table/head";
import { TableHeadCell } from "~/components/table/head-cell";
import { TableRow } from "~/components/table/row";
import { Truncated } from "~/components/truncated";

import { Widget, WidgetBody, WidgetHeader } from "../_widget";

interface BuiltInVariable {
	name: string;
	description: React.ReactNode;
}

export interface BuiltInVariablesTableProps {
	title: React.ReactNode;
	variables: ReadonlyArray<BuiltInVariable>;
}

export const BuiltInVariablesTable: React.FC<BuiltInVariablesTableProps> = ({ title, variables }) => {
	const isExpanded = usePermanent(() => Signal(false));

	return (
		<Widget card isExpanded={isExpanded}>
			<WidgetHeader title={title} />

			<WidgetBody>
				<Table className="grid-cols-[max-content_auto]">
					<TableHead>
						<TableHeadCell>Name</TableHeadCell>
						<TableHeadCell>Description</TableHeadCell>
					</TableHead>

					<TableBody each={variables}>
						{({ name, description }) => (
							<TableRow key={name}>
								<TableCell>
									<Truncated className="code" el="code">
										{name}
									</Truncated>
								</TableCell>

								<TableCell className="prose">{description}</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</WidgetBody>
		</Widget>
	);
};
